<template>
  <div class="apps">
    <ag-table
      :data-source-api="getAllApps"
      :grid-options="gridOptions"
      :permissions="permissions"
      :rtl="false"
      :is-entities-response="false"
      @emitAddNewRecord="onCreateApp()"
    />
    <tm-popup
      :submit="onAppPopupSubmit"
      :title="appPopupTitle"
      ref="appPopup"
    >
      <div class="vx-row justify-start">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input
            class="w-full"
            name="اسم المشروع"
            placeholder="اسم المشروع"
            type="text"
            validation-rules="required"
            v-model="app.name"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select
            class="w-full"
            :options="getAppStatusOptions"
            label="name"
            validation-rules="required"
            name="حالة المشروع"
            :reduce="name => name.value"
            v-model="app.status"
          />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AgTableBtnCell from "../../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "../../../shared/shared-components/ag-grid/AgButton";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import FilePondComponent from "@/app/shared/shared-components/FilePondComponent";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import TmSelect from "@/app/shared/shared-components/TmSelect";

const appsRepo = RepositoryFactory.get('appsRepository');
export default {
  name: "Apps",
  components: {
    AgTable,
    TmInput,
    AgTableBtnCell,
    TmPopup,
    AgButton,
    TmTextArea,
    FilePondComponent,
    TmSelect
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      appPopupTitle: '',
      app: {
        name: null,
        status: 'active',
      },
      status: {
        active: 'فعّال',
        inactive: 'معطّل',
      },
      permissions: {
          add: 'apps_manage',
          edit: 'apps_manage',
          delete: 'apps_manage',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'المعرف',
          field: 'id',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'اسم المشروع',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'حالة المشروع',
          field: 'status',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: true,
          valueGetter:
            function getObject(params) {
              return self.status[params.data.status] || '-';
            },
        },
        {
          headerName: 'الإجراءات',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            deleteRecord: function (id) {
              self.onDeleteApp(id);
            },
            editRecord: function (app) {
              self.onUpdateApp(app);
            },
            actions: ['edit', 'delete'],
            permissions: self.permissions
          },
        }
      ];
    },
    async onDeleteApp(appId) {
      await appsRepo.removeApp(appId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    onUpdateApp(app) {
      this.appPopupTitle = 'تعديل معلومات المشروع';
      this.resetAppForm();
      Object.assign(this.app, app);
      this.$refs.appPopup.open();
    },
    onCreateApp() {
      this.appPopupTitle = 'إضافة مشروع جديد';
      this.resetAppForm();
      this.$refs.appPopup.open();
    },
    resetAppForm() {
      Object.assign(this.app, {
        name: null,
        status: 'active',
      });
    },
    async onAppPopupSubmit() {
      try {
        let res = null;
        if (this.appPopupTitle == 'إضافة مشروع جديد') {
          res = await appsRepo.createApp(this.app);
        } else {
          res = await appsRepo.updateApp(this.app);
        }

        if (res.status === 201 || res.status === 200) {
          this.$refs.appPopup.close();
          await this.gridApi.refreshServerSideStore({ purge: true });
        }
      } catch (err) {
        this.$refs.appPopup.endLoading();
      }
    },
    async getAllApps(query) {
      return await appsRepo.fetchApps(query);
    },
  },
  computed: {
    getAppStatusOptions() {
      return Object.keys(this.status).map(key => ({
        name: this.status[key],
        value: key
      }));
    }
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>